import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m33.66 36.413 5.28 5.3c.864.868 2.16-.433 1.296-1.3l-33-33.127c-.864-.867-2.16.434-1.296 1.301l4.354 4.371Q6.497 15.52 3.328 19.66a6.46 6.46 0 0 0-.004 7.843c5.484 7.181 12.4 10.8 20.68 10.8q5.182 0 9.655-1.89m-1.41-1.415-3.52-3.532a9.1 9.1 0 0 1-4.725 1.316c-5.063 0-9.167-4.12-9.167-9.202a9.2 9.2 0 0 1 1.31-4.744l-4.531-4.55q-3.715 2.421-6.835 6.495a4.615 4.615 0 0 0-.003 5.603C9.925 33.12 16.31 36.462 24.005 36.462q4.412 0 8.244-1.464M17.494 20.187a7.35 7.35 0 0 0-.824 3.393c0 4.065 3.284 7.361 7.334 7.361a7.3 7.3 0 0 0 3.38-.826z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M14.894 11.501a.914.914 0 0 0 1.174.55q3.704-1.353 7.937-1.354c7.679 0 14.06 3.344 19.215 10.087a4.615 4.615 0 0 1 .003 5.597q-2.766 3.626-6.01 5.94a.92.92 0 0 0-.216 1.284.914.914 0 0 0 1.278.217q3.476-2.483 6.403-6.322a6.46 6.46 0 0 0-.004-7.836C39.182 12.478 32.27 8.857 24.004 8.857q-4.55 0-8.563 1.465a.92.92 0 0 0-.548 1.18"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M20.593 17.062a7.3 7.3 0 0 1 3.723-.837 5.5 5.5 0 0 0-.311 1.834c0 3.049 2.462 5.52 5.5 5.52.63 0 1.247-.107 1.826-.311q.007.155.007.312a7.35 7.35 0 0 1-.777 3.302.92.92 0 0 0 .407 1.235.915.915 0 0 0 1.23-.409 9.27 9.27 0 0 0 .776-6.031.916.916 0 0 0-1.411-.571 3.64 3.64 0 0 1-2.058.633 3.674 3.674 0 0 1-3.667-3.68c0-.749.222-1.461.631-2.066a.92.92 0 0 0-.569-1.418 9.17 9.17 0 0 0-6.162.859.92.92 0 0 0-.384 1.243c.236.45.79.622 1.239.385"
    }
  )
);
var SvgVisibleOffOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var VisibleOffOutlined_default = SvgVisibleOffOutlined;

export { VisibleOffOutlined_default as default };
